<template>
    <div class="p-4">
        <div class="flex-1 min-w-0 flex justify-between items-center">
            <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate mb-6">
                Etage 3 London
            </h2>
            <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate mb-6">
                {{ timestamp }}
            </h2>
            <img class="object-scale-down h-20 rounded-lg" src="/files/anteonImmobilienLogo.png" alt="">
        </div>
        <div class="relative mt-4 mb-4">
            <div class="absolute inset-0 flex items-center" aria-hidden="true">
                <div class="w-full border-t border-gray-300"></div>
            </div>
        </div>
        <div class="justify-center">
            <img class="object-scale-down rounded-lg " src="/files/anteonPlaeneDemo.png" alt="">
        </div>
    </div>
</template>

<script>


    export default {
        name: "DemoMap",
        components: {
        },

        data: () => ({
            date: new Date().toISOString().substr(0, 10),
            timestamp: "",
            Bookings: [],
            checkedIn: false,
        }),

        computed: { 
        },

        created() {
            setInterval(this.getNow, 1000);
        },

        methods: {
            getNow() {
                const today = new Date();
                const time = ("0" + today.getHours()).slice(-2) + ":" + ("0" + today.getMinutes()).slice(-2) + ":" + ("0" + today.getSeconds()).slice(-2);
                this.timestamp = time.substr(0, 10);
            },
        }
    }
</script>

<style scoped>

</style>
